import React from 'react';
import GenericCadastroPage from './GenericCadastroPage';

export default function NaturezaProcessoPage() {
  const columns = [
    { key: 'descricao', label: 'Descrição' },
  ];

  const fields = [
    { name: 'descricao', label: 'Descrição', required: true },
  ];

  return (
    <GenericCadastroPage
      title="Naturezas de Processo"
      description="Gerencie as classificações de natureza de processo."
      tableName="natureza_processo_v2"
      columns={columns}
      fields={fields}
    />
  );
}